var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlovakia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#204c9e",
    d: "M1 11H31V21H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z",
    transform: "rotate(180 16 24)",
    fill: "#db362f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z",
    opacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z",
    fill: "#fff",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z",
    fill: "#db362f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.673,19.945v-4.462c-1.511,0-1.94,.134-2.392,.27,.042-.456,.042-.915,0-1.371,.452,.137,.881,.27,2.392,.27v-1.24c-.477,0-1.135,.019-1.892,.277,.043-.457,.043-.917,0-1.374,.757,.254,1.415,.274,1.892,.274,0-.359-.111-1.132-.251-1.772,.436,.039,.874,.039,1.31,0-.14,.639-.251,1.412-.251,1.772,.477,0,1.135-.019,1.892-.274-.043,.457-.043,.917,0,1.374-.757-.258-1.415-.277-1.892-.277v1.24c1.511,0,1.94-.134,2.392-.27-.042,.456-.042,.915,0,1.371-.452-.137-.881-.27-2.392-.27v4.462h-.808Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.076,22.044c1.241-.602,2.761-1.542,3.742-3.038-.007-.014-.011-.031-.017-.045-.56-1.184-1.576-1.367-2.268-.409-.089-.209-.191-.399-.304-.565-.805-1.181-1.973-.929-2.609,.565-.287-.397-.645-.614-1.014-.614-.518,0-.973,.424-1.268,1.072,.982,1.494,2.499,2.432,3.739,3.034Z",
    fill: "#204c9e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.076,22.235l-.075-.036c-1.348-.654-2.385-1.395-3.169-2.266-1.103-1.225-1.668-2.687-1.679-4.347,0-3.537,.177-5.353,.179-5.371l.015-.155H15.806l.015,.155c.002,.018,.179,1.834,.179,5.37-.012,1.661-.577,3.123-1.679,4.348-.785,.871-1.821,1.613-3.169,2.266l-.075,.036ZM6.66,10.404c-.041,.505-.164,2.246-.164,5.181,.011,1.572,.546,2.958,1.591,4.118,.74,.822,1.718,1.526,2.989,2.151,1.271-.625,2.249-1.329,2.989-2.151,1.045-1.16,1.58-2.546,1.591-4.119,0-2.934-.122-4.675-.164-5.18H6.66Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlovakia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Slovakia.27395708e44217d7436434bb4677f534.svg";